import { createFileRoute } from '@tanstack/react-router';

import { CrmView } from '../../raporty/crm/CrmView';

export const Route = createFileRoute('/raporty/aktywnosc-crm')({
  component: CrmView,
});
